import CSV from "csv.js/csv";
import { strings } from "../i18n";

/**
 * Parse to JSON Array
 */
const parse = (columns: Array<string>, csv: string, onError: Function) => {
    const next = [];
    const records = CSV.parse(csv);
    const csvColumnIndices = columns.reduce((aggregate, column) => {
        const index = records[0].findIndex((value) => column === value);
        if (index < 0)
            onError(
                strings("errors.csvInvalidColumns", {
                    received: records[0],
                    required: columns
                })
            );
        return { ...aggregate, [column]: index };
    }, {});
    for (let row = 1; row < records.length; row++) {
        const record = records[row];
        next.push(
            columns.reduce(
                (aggregate, column) => ({
                    ...aggregate,
                    [column]: record[csvColumnIndices[column]]
                }),
                { row }
            )
        );
    }
    return next;
};

/**
 * Serialize to CSV
 */
const serialize = (columns: Array<any>, rows: Array<any>) =>
    CSV.serialize({
        fields: columns.map(({ id }) => ({ id })),
        records: rows
    });

/**
 * Download to CSV file
 */
export const download = (
    columns: Array<any>,
    rows: Array<any>,
    filename: string
) => {
    const csv = serialize(columns, rows);
    const blob = new Blob([csv], { type: "text/csv" });
    const a = document.createElement("a");
    a.href = window.URL.createObjectURL(blob);
    a.download = `${filename}-${new Date().toISOString()}.csv`;
    document.body.appendChild(a);
    a.click();
    a.remove();
};

/**
 * Upload from CSV File
 */
export const upload = async (columns: Array<any>) =>
    new Promise((resolve, reject) => {
        const input = document.createElement("input");
        input.setAttribute("accept", ".csv");
        input.setAttribute("type", "file");
        input.onchange = (event: Event) => {
            const reader = new FileReader();
            reader.onload = (e: Event) => {
                const columnIds = columns.map(({ id }) => id);
                const json = parse(columnIds, e.target.result, reject);
                resolve(json);
            };
            reader.readAsText(event.target.files[0], "UTF-8");
        };
        input.click();
    });

export default {
    download,
    upload
};
